"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const system_1 = require("@chakra-ui/system");
const utils_1 = require("@chakra-ui/utils");
const VARIANT_MAPPING = {
    display1: 'h1',
    display2: 'h1',
    h1: 'h1',
    h2: 'h2',
    h3: 'h3',
    h4: 'h4',
    h5: 'h5',
    h6: 'h6',
    subtitle1: 'p',
    subtitle2: 'p',
    subtitle3: 'p',
    body1: 'p',
    body2: 'p',
    body3: 'p',
    caption: 'span',
};
const Typography = (0, system_1.forwardRef)((_a, ref) => {
    var { variant = 'h2', as } = _a, props = __rest(_a, ["variant", "as"]);
    const styles = (0, system_1.useStyleConfig)('Typography', { variant });
    const component = as || VARIANT_MAPPING[variant];
    const _b = (0, system_1.omitThemingProps)(props), { className, align, decoration, casing } = _b, baseProps = __rest(_b, ["className", "align", "decoration", "casing"]);
    const aliasedProps = (0, utils_1.filterUndefined)({
        textAlign: align,
        textDecoration: decoration,
        textTransform: casing,
    });
    return ((0, jsx_runtime_1.jsx)(system_1.chakra.p, Object.assign({ as: component, ref: ref, className: (0, utils_1.cx)('chakra-typography', className), __css: styles }, aliasedProps, baseProps)));
});
exports.default = Typography;
